module.exports = __webpack_public_path__ + "img/gif-flame.fcbea208.gif";